import clsx from 'clsx';
import React, { useContext } from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { StaticDataContext } from '@components/evidence/static-data-provider/static-data-provider';
import { useStyles } from '../dashboard';
import { ResultTable } from './result-table';
import {
  useDecisionColumns,
  useDocumentColumns,
  useEsFileColumns,
} from './search-columns';
import { DashboardSearchContext } from './search-dashboard-context';

export function DashboardSearchResults() {
  const classes = useStyles();

  const {
    documentTypes,
    documentDeliveryMethods,
    documentDispatchStates,
    agendas,
    states,
    anonymizationRequests,
    decisionForms,
  } = useContext(StaticDataContext);

  const { esFileSource, documentSource, decisionSource, wasSubmitted } =
    useContext(DashboardSearchContext);

  const documentColumns = useDocumentColumns({
    documentTypes,
    documentDeliveryMethods,
    documentDispatchStates,
  });

  const esFileColumns = useEsFileColumns({ agendas, states });
  const decisionColumns = useDecisionColumns({
    anonymizationRequests,
    decisionForms,
  });

  if (!wasSubmitted) {
    return null;
  }

  return (
    <Grid
      item
      xs={12}
      className={clsx(classes.wrapper, classes.resultsSection)}
    >
      <Typography
        variant="subtitle1"
        className={clsx(classes.padded, classes.subtitle)}
      >
        Výsledky
      </Typography>
      <ResultTable
        title="Spisy"
        source={esFileSource}
        columns={esFileColumns}
      />
      <ResultTable
        title="Dokumenty"
        source={documentSource}
        columns={documentColumns}
      />
      <ResultTable
        title="Rozhodnutí"
        source={decisionSource}
        columns={decisionColumns}
      />
    </Grid>
  );
}
